var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7164 0.716742C10.9872 0.734577 11.1483 0.990116 11.0412 1.25556C10.8691 1.68886 10.6877 2.12197 10.5125 2.55521C9.41299 5.25517 8.31044 7.952 7.21091 10.652C7.12016 10.8716 6.95776 10.979 6.77067 10.9383C6.60205 10.8979 6.51193 10.7853 6.47522 10.6216C6.36303 10.0809 6.25084 9.5403 6.13551 9.00269C5.93917 8.05737 5.73975 7.11198 5.5434 6.16666C5.52656 6.08634 5.48715 6.05477 5.41048 6.03782C3.9545 5.67585 2.49852 5.31389 1.04563 4.95198C0.766711 4.88168 0.632216 4.67898 0.716994 4.45C0.762682 4.32481 0.859528 4.25911 0.980633 4.21237C2.4021 3.7 3.82356 3.18762 5.24509 2.67218C7.00479 2.04059 8.75532 1.40574 10.5089 0.774025C10.5771 0.75081 10.6483 0.736882 10.7164 0.716742Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateIcon);
export default __webpack_public_path__ + "static/media/locate-icon.f13bbb7ee0590786d8be9e86e23cfebd.svg";
export { ForwardRef as ReactComponent };